module.exports = __webpack_public_path__ + "img/bgr-blocks.7ba702a4.svg";